/*
 * Telecom problem-framing stats - shown in MetricsBand below the hero.
 */

export const TELECOM_PROBLEM_METRICS = [
  {
    value: '31%',
    labelKey: 'industries_telecom.stats_label_1',
  },
  {
    value: '41%',
    labelKey: 'industries_telecom.stats_label_2',
  },
  {
    value: '6–7x',
    labelKey: 'industries_telecom.stats_label_3',
  },
];
